import { DiscountRepository } from "core/repository";
import { Base2Presenter } from "core/presenter";
import { fn } from "util";

class DataTablePresenter extends Base2Presenter {
  initialState() {
    return {
      loading: false,
      result: [],
      order: {
        field: "description",
        direction: "ASC"
      },
      pagination: {
        perPage: 25,
        currentPage: 1,
        total: 0
      }
    };
  }

  onStart() {
    this.load();
  }

  async load() {
    this.enqueue({ loading: true });
    this.renewCancelToken();

    const { pagination } = this.viewModel;
    const repositoryResult = await DiscountRepository.getListOnline({
      order: [this.viewModel.order],
      pagination: {
        page: pagination.currentPage,
        perPage: pagination.perPage
      },
      filters: await this.getFilters()
    });

    if (repositoryResult.success) {
      this.enqueue(vm => ({
        result: repositoryResult.data,
        pagination: {
          ...vm.pagination,
          total: repositoryResult.total,
          perPage: repositoryResult.perPage
        }
      }));
    } else {
      this.sendNotification({
        type: "error",
        title: "Oops...",
        content:
          "Não conseguimos carregar os dados. Por favor, tente novamente mais tarde ou entre em contato com o suporte."
      });
    }

    this.enqueue({ loading: false });
  }

  async getFilters() {
    const currentUser = await this.mRuntime.get("currentUser");
    const { description, type, enabled } = this.props.filter;

    const filters = [
      {
        connector: "AND",
        field: "company_uuid",
        operation: "EQ",
        value: currentUser.company_uuid
      }
    ];

    if (!fn.isBlank(description)) {
      filters.push({
        connector: "AND",
        field: "description",
        operation: "LIKE",
        value: description
      });
    }

    if (!fn.isBlank(type)) {
      if (type === "all") {
        filters.push({
          connector: "AND",
          field: "type",
          operation: "IN",
          value:
            "variable_percentual|fixed_percentage|fixed_value|variable_value"
        });
      } else {
        filters.push({
          connector: "AND",
          field: "type",
          operation: "EQ",
          value: type
        });
      }
    }

    if (!fn.isBlank(enabled)) {
      if (enabled === "all") {
        filters.push({
          connector: "AND",
          field: "enabled",
          operation: "IN",
          value: "true|false"
        });
      } else {
        filters.push({
          connector: "AND",
          field: "enabled",
          operation: "EQ",
          value: enabled
        });
      }
    }

    return filters;
  }

  handleChangeSwitch(index, discount, value) {
    const message = {
      true: "ativar",
      false: "desativar"
    };

    this.sendNotification({
      type: "confirmation",
      title: "Você tem certeza?",
      content: `Tem certeza que deseja ${message[value]} o desconto ${discount.description}?`,
      actions: [
        {
          label: "Voltar"
        },
        {
          label: `Sim, quero ${message[value]}`,
          type: "accent",
          callback: () => this.confirmChange(index, discount, value)
        }
      ]
    });
  }

  async confirmChange(index, discount, value) {
    this.enqueue({ loading: true });

    const message = {
      true: "ativado",
      false: "desativado"
    };

    const params = {
      ...discount,
      enabled: value
    };
    delete params.created_at;

    const result = await DiscountRepository.updateDiscount(
      discount.uuid,
      params
    );

    if (result.success) {
      this.enqueue(vm => {
        const discounts = vm.result;
        discounts[index]["enabled"] = value;

        return { result: discounts };
      });

      this.sendNotification({
        type: "success",
        content: `Desconto ${message[value]} com sucesso!`
      });
    } else {
      this.sendNotification({
        type: "error",
        title: "Oops...",
        content:
          "Não conseguimos atualizar os dados desse desconto. Por favor, tente novamente mais tarde ou entre em contato com o suporte."
      });
    }

    this.enqueue({ loading: false });
  }

  async onFilterChange(fields) {
    this.enqueue({ filters: fields });
    await this.load();
  }

  onPageChange(page) {
    this.enqueue(
      vm => ({
        pagination: {
          ...vm.pagination,
          currentPage: page
        }
      }),
      () => this.load()
    );
  }

  onOrderChange(field, direction) {
    this.enqueue(
      vm => ({
        order: {
          ...vm.order,
          field,
          direction
        }
      }),
      () => this.load()
    );
  }

  onViewDiscount(discount) {
    this.navigateTo("app.registration.discount.info", {
      discountUuid: discount.uuid
    });
  }

  onEditDiscount(discount) {
    this.navigateTo("app.registration.discount.edit", {
      discountUuid: discount.uuid
    });
  }
}

export default DataTablePresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/discount/list/data-table/presenter.js